// Shared placeholder used for empty ("upload to load data") and error states so a
// missing/invalid sheet renders as a per-section card rather than a full-page failure.

interface SectionStateCardProps {
    variant: 'empty' | 'error';
    message?: string;
}

const SectionStateCard = ({ variant, message }: SectionStateCardProps) => {
    const isError = variant === 'error';
    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center text-center p-4 rounded"
            style={{
                minHeight: 140,
                border: `1px dashed ${isError ? '#e15759' : '#cdd4da'}`,
                background: isError ? '#fdf3f3' : '#f7f9fb',
                color: isError ? '#b3413f' : '#7a8794',
            }}>
            <i className={`icon-${isError ? 'info' : 'upload'} font-20 mb-2`} aria-hidden="true"></i>
            <span className="font-14 font-500">
                {message || (isError ? 'This section could not be loaded.' : 'Upload Excel to load data')}
            </span>
        </div>
    );
};

export default SectionStateCard;
